import yup from 'yup';

const { accreditationAnswerMap } = require('buyside/util/constantsFromRails.json');

const optionText = 'Please select an option.';

export const investorStatusSchema = yup.object().shape({
  netWorthReq: yup
    .boolean()
    .oneOf([true, false], optionText)
    .nullable(),
  incomeReq: yup
    .boolean()
    .oneOf([true, false], optionText)
    .nullable()
});

export const financialBackgroundSchema = yup.object().shape({
  netWorth: yup
    .string()
    .oneOf(accreditationAnswerMap.net_worth, optionText)
    .nullable(),
  next12MoAllocation: yup
    .string()
    .oneOf(accreditationAnswerMap.next_12_mo_allocation, optionText)
    .nullable(),
  investmentSize: yup
    .string()
    .oneOf(accreditationAnswerMap.investment_size, optionText)
    .nullable(),
  yearsInvesting: yup
    .string()
    .oneOf(accreditationAnswerMap.years_investing, optionText)
    .nullable()
});

export const previousInvestmentsSchema = yup.object().shape({
  bonds: yup
    .string()
    .oneOf(accreditationAnswerMap.bonds, optionText)
    .nullable(),
  hedgeFunds: yup
    .string()
    .oneOf(accreditationAnswerMap.hedge_funds, optionText)
    .nullable(),
  realEstate: yup
    .string()
    .oneOf(accreditationAnswerMap.real_estate, optionText)
    .nullable(),
  foreignCurrencies: yup
    .string()
    .oneOf(accreditationAnswerMap.foreign_currencies, optionText)
    .nullable(),
  futuresOrCommodities: yup
    .string()
    .oneOf(accreditationAnswerMap.futures_or_commodities, optionText)
    .nullable(),
  privateEquityFunds: yup
    .string()
    .oneOf(accreditationAnswerMap.private_equity_funds, optionText)
    .nullable(),
  publiclyTradedStocks: yup
    .string()
    .oneOf(accreditationAnswerMap.publicly_traded_stocks, optionText)
    .nullable(),
  privateCompanies: yup
    .string()
    .oneOf(accreditationAnswerMap.private_companies, optionText)
    .nullable()
});
